import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ru from "./ru.json";

/**
 * Ресурсы подключаются инлайном, без http-backend: лишний сетевой запрос ради
 * файла в двадцать килобайт не окупается.
 *
 * Язык один — русский, как и в мини-аппе. `ru.json` заводится с первого экрана
 * (правило ТЗ №7): русских литералов в JSX быть не должно, иначе добавление
 * второго языка потом потребует переписывать компоненты. Единственное
 * исключение — сообщения бэкенда: они приходят готовыми строками и переводу
 * на клиенте не подлежат.
 */
void i18n.use(initReactI18next).init({
  resources: { ru: { translation: ru } },
  lng: "ru",
  fallbackLng: "ru",
  // React экранирует сам, двойное экранирование ломает кавычки и тире.
  interpolation: { escapeValue: false },
});

export { i18n };
export type TranslationKeys = typeof ru;
